import { useParams } from 'react-router';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import type { CustomerDetailsType } from '@customTypes/customer';

const useGetDetails = () => {
  const { id } = useParams();

  const [customer, setCustomer] = useState<CustomerDetailsType | null>(null);
  const [loading, setLoading] = useState(true);

  const getCustomer = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(`/customer/${id}`);
      setCustomer(response.data);
    } catch (error) {
      toast.error('Erro ao carregar os detalhes. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to load customer details'), {
        error,
        customerId: id,
      });
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    getCustomer();
  }, [getCustomer]);

  return {
    getCustomer,
    customer,
    loading,
  };
};

export default useGetDetails;
